import { render, staticRenderFns } from "./SupportAppeal.vue?vue&type=template&id=3b5d1b5c&scoped=true"
import script from "./SupportAppeal.vue?vue&type=script&lang=js"
export * from "./SupportAppeal.vue?vue&type=script&lang=js"
import style0 from "./SupportAppeal.vue?vue&type=style&index=0&id=3b5d1b5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5d1b5c",
  null
  
)

export default component.exports